import { useState, useEffect } from "react";
import {getInspectionHistoryResult} from "../../api/searchs/inspectionHistoryResultApi";
import {errorStatusHandle} from "../../utils/error-utils";
import {getFormErrorResponseData} from "../../utils";
import {useDispatch} from "react-redux";
import {clearComponentLoading, setComponentLoading} from "../../store/actions";
import _ from "lodash";

const useSearchInspectionHistoryResult = (params = {}, workflowId = null) => {
  const paramUrl = window.location.search;
  const dispatch = useDispatch();
  const [workflowList, setWorkflowList] = useState([]);
  const [workflow, setWorkflow] = useState();
  const [searchResults, setSearchResults] = useState([]);
  const [searchInformation, setSearchInformation] = useState([]);
  const [numPages, setNumPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [errorMessages, setErrorMessages] = useState({});

  useEffect(() => {
    if (!_.isEmpty(paramUrl) && Object.keys(params).length === 0) return;
    if (workflowId !== null) {
      params = {...params, workflow_id: workflowId}
    }
    setSearchResults([]);
    dispatch(setComponentLoading('search-inspection-results'));
    getInspectionHistoryResult(params).then((response) => {
      if (response.success) {
        setErrorMessages({});
        setWorkflowList(response.data?.workflow_list);
        setWorkflow(response.data?.workflow);
        setSearchInformation(response.data.search_information);
        setSearchResults(response.data.inspections);
        setTotalCount(response.data.pagination.total_count);
        setNumPages(response.data.pagination.total_pages);
        dispatch(clearComponentLoading('search-inspection-results'));
      }
    }).catch(e => {
      dispatch(clearComponentLoading('search-inspection-results'));
      errorStatusHandle(e.response);
      if (e.response.status === 400) {
        let errorResponse = getFormErrorResponseData(e);
        if (errorResponse) {
          setErrorMessages(errorResponse);
        }
      }
    });
  }, [params, workflowId]);

  return { workflowList, workflow, searchInformation, searchResults, numPages, totalCount, errorMessages };
}

export { useSearchInspectionHistoryResult }